import { Timer } from "./Time/Timer";

export interface IEaseFunction {
    (k: number): number;
}



export class PopupMessageType {
    /**
    * (RO) Vzdalenost, kterou ma zprava urazit
    */
    get moveDistance(): number { return this._moveDistance; }
    private _moveDistance: number;

    /**
    * (RO) Doba, za kterou ma zprava vzdalenost urazit
    */
    get moveTime(): number { return this._moveTime; }
    private _moveTime: number;

    /**
    * (RO) Ease funce, ktera se ma pouzit pro presun
    */
    get moveEase(): IEaseFunction { return this._moveEase; }
    private _moveEase: IEaseFunction;

    /**
    * (RO) Prodleva, nez se zacne menit alfa
    */
    get alphaDelay(): number { return this._alphaDelay; }
    private _alphaDelay: number;

    /**
    * (RO) Cas, po ktery se ma menit alfa
    */
    get alphaTime(): number { return this._alphaTime; }
    private _alphaTime: number;

    /**
    * (RO) Ease funkce pro zmenu alfy
    */
    get alphaEase(): IEaseFunction { return this._alphaEase; }
    private _alphaEase: IEaseFunction;

    //---------------------------------------------------------------------
    /**
     * Konstruktor
     * @param moveDistance Vzdalenost, kterou ma zprava urazit
     * @param moveTime Doba, za kterou ma zprava vzdalenost urazit (ms)
     * @param moveEase Ease funce, ktera se ma pouzit pro presun
     * @param alphaDelay Prodleva, nez se zacne menit alfa (ms). Pokud  nezadano, tak se alfa nepocita.
     * @param alphaTime Cas, po ktery se ma menit alfa (ms)
     * @param alphaEase Ease funkce pro zmenu alfy
     */
    //---------------------------------------------------------------------
    constructor(moveDistance: number, moveTime: number, moveEase: IEaseFunction, alphaDelay: number = -1, alphaTime?: number, alphaEase?: IEaseFunction) {
        this._moveDistance = moveDistance;
        this._moveTime = moveTime;
        this._moveEase = moveEase;
        this._alphaDelay = alphaDelay;
        this._alphaTime = alphaTime;
        this._alphaEase = alphaEase;
    }
}



export abstract class PopupMessageBase {
    protected _timer: Timer;

    protected _active: boolean = false;
    protected _type: PopupMessageType;

    protected _startPos: pc.Vec3;
    protected _startTime: number;
    protected _moveAngle: number;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor() {
        this._startPos = new pc.Vec3();
        this._moveAngle = -90 * Math.PI / 180;
    }

    //---------------------------------------------------------------------
    /**
     * Aktualizace
     * @return True, pokud je zprava stale aktivni
     */
    //---------------------------------------------------------------------
    update(): boolean {
        if (!this._active)
            return false;

        let time = this._timer.time - this._startTime;
        let completeMask = 0;

        // Pohyb
        let progress = time / this._type.moveTime;

        if (progress >= 1) {
            progress = 1;
            completeMask |= 1;
        }

        let progressEased = this._type.moveEase(progress);

        let x = this._startPos.x + (Math.cos(this._moveAngle) * (progressEased * this._type.moveDistance));
        let y = this._startPos.y - (Math.sin(this._moveAngle) * (progressEased * this._type.moveDistance));

        // Alfa
        let alpha = 1;

        if (this._type.alphaDelay >= 0) {
            if (time > this._type.alphaDelay) {
                progress = (time - this._type.alphaDelay) / this._type.alphaTime;

                if (progress >= 1) {
                    progress = 1;
                    completeMask |= 2;
                }

                alpha = 1 - this._type.alphaEase(progress);
            }
        }
        else {
            completeMask |= 2;
        }

        // Aktualizovat kontejner
        this.updateContainer(x, y, alpha);

        if (completeMask == 3) {
            this.release();
            return false;
        }

        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected abstract updateContainer(x: number, y: number, alpha: number): void;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected showMessage(x: number, y: number, z: number, type: PopupMessageType, timer: Timer): void {
        this._timer = timer;
        this._type = type;
        this._active = true;

        this._startPos.set(x, y, z);
        this._startTime = timer.time;

        this.updateContainer(x, y, 1);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    release(): void {
        this._active = false;
    }
}
